<template>
  <div>
    <div class="chatContainer" id="chatContainer">
      <!-- 連線中斷提示：斷線時訊息不會進來，一定要讓使用者看得到 -->
      <div class="signalr-banner" v-if="isReconnecting">
        連線中斷，正在重新連線…
      </div>
      <div class="chat-head">
        <!-- <img
          src="../../../static/img/open_in_new.png"
          style=" cursor: pointer;"
          title
          @click="OpenURL"
          v-show="openNewShow"
        />-->
        <ChatSearch></ChatSearch>

        <div class="socialTab">
          <div
            v-for="(provider, index) in providerList"
            :class="tabclass(provider)"
          >
            <a @click="ChangeProvider(provider.Id, provider.Code)">
              <img
                v-if="provider.Code === 'LINE'"
                src="../../../static/img/line_logo_A.svg"
                alt
                title="LINE"
              />
              <img
                v-if="provider.Code === 'LINE-Abroad'"
                src="../../../static/img/line_abroad_logo_A.svg"
                alt
                title="LINE留遊學"
              />
              <img
                v-if="provider.Code === 'FB-TutorABC'"
                src="../../../static/img/fb_logo.svg"
                alt
                title="TutorABC"
              />
              <img
                v-if="provider.Code === 'FB-tutorJr'"
                src="../../../static/img/fb_logo2.svg"
                alt
                title="tutorJr-讓孩子的視界，是全世界"
              />
              <img
                v-if="provider.Code === 'WeChat'"
                src="../../../static/img/wechat_logo.svg"
                alt
                title="New TutorABC 新麦奇好学">
              <img
                v-if="provider.Code === 'WeChat-tutorabcmaiqi'"
                src="../../../static/img/wechat_logo.svg"
                alt
                title="TutorABC麦奇好学">
              <img
                v-if="provider.Code === 'WeCom'"
                src="../../../static/img/wecom_logo.png"
                alt
                title="New TutorABC 新麦奇好学-企業微信">
            </a>
          </div>
        </div>
      </div>

      <!-- 訊息記錄 -->
      <ChatLog :messages="messages"></ChatLog>
      <!-- 貼圖選單 -->
      <Sticker
        :roomInfo="roomInfo"
        :staffInfo="staffInfo"
        v-show="stickerPackagesVisible()"
      ></Sticker>
      <!-- 工具列 -->
      <ChatToolBar :roomInfo="roomInfo" :staffInfo="staffInfo"></ChatToolBar>
      <!-- 訊息輸入 -->
      <ChatMessageInput :roomInfo="roomInfo"></ChatMessageInput>
    </div>
  </div>
</template>


<script>
// 聊天室

import ChatLog from "../Main/ChatLog.vue";
import ChatToolBar from "../Main/ChatToolBar.vue";
import ChatMessageInput from "../Main/ChatMessageInput.vue";
import ChatSearch from "../Main/ChatSearch.vue";
import Sticker from "../Main/Sticker.vue";

import "signalr";
import Global from "@/components/Global";
import { isMobile } from "mobile-device-detect";
import { ChatContainerHandler } from "@/handler/ChatContainerHandler.js";
import { SocialPairedBasisInfoHandler } from "@/handler/SocialPairedBasisInfoHandler.js";
import {
  SignalrConnectionHandler,
  SignalrStatus,
} from "@/handler/SignalrConnectionHandler.js";
import store from "@/vuex/store_chat.js";
import store_sticker from "@/vuex/store_sticker.js";
import { Loading } from "element-ui";
import http from "../../http.js";
import qs from "qs";

$.urlParam = function (name, url) {
  var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(url);
  return results[1] || 0;
};

export default {
  name: "ChatContainer",
  components: { ChatLog, ChatMessageInput, ChatToolBar, ChatSearch, Sticker },
  data() {
    return {
      staffInfo: [],
      roomInfo: [],
      messages: [],
      sessionId: "",
      conn: [],
      showSearch: false,
      openNewShow: false,
      providerList: [],
      token: "",
      isAlert: false,
      maxTime: 180,
      runTime: 180,
      userProfiles: [],
      connStatus: null,
      // 存在 this 上，beforeDestroy 才清得掉。放區域變數的話元件銷毀後
      // 閒置計時器會繼續倒數，最後把刻意停掉的連線復活成殭屍。
      idleTimerId: null,
      idleActivityHandler: null,
    };
  },
  computed: {
    isReconnecting() {
      return this.connStatus === SignalrStatus.reconnecting;
    },
  },
  created() {
    //todo 為了解決手機板聊天室去了別頁再回來就死掉的問題，使用笨方法立flag讓畫面自動重整。
    if (sessionStorage.getItem("reloadFlag") == 1) {
      window.sessionStorage.setItem("reloadFlag", 0);
      window.location.reload();
      return;
    }
    this.token = this.$route.query.token;
    this.initdata(this.token);
    this.openNewShow = true;

    //頁面閒置處理
    const self = this;
    // 保留 handler 參照，beforeDestroy 才能只移除自己這一個
    // （不能用匿名函式，也不該用共用 namespace 以免誤殺其他實例的 handler）
    this.idleActivityHandler = function (e) {
      self.runTime = self.maxTime; // reset
    };
    $("body").on("keydown mousemove mousedown", this.idleActivityHandler);
    self.StartIdleTimer();
    window.sessionStorage.setItem("reloadFlag", 1);
  },
  mounted() {
    window.addEventListener("focus", this.handleWinFocus);
  },
  // 元件銷毀時要把連線和所有計時器/監聽一起收掉。
  //
  // 連線：SignalrConnectionHandler 會無限退避重連，沒停的話 SPA route 切換後
  // 會留下永遠重連的殭屍連線，而且每次重連都會再跑一次 onConnected
  // （AddGroup / GetDataByToken），觸發 server 端的單一登入檢查去 closepage
  // 掉當前活著的那條連線。
  //
  // 閒置計時器：不清掉的話會精準抵銷上面停連線的動作 —— 已銷毀的實例繼續
  // 倒數，時間到跳出「頁面閒置過久」（element-ui 的 $alert 是全域服務，
  // 元件銷毀後照樣彈），使用者按確認就執行 conn.start()，stopped 旗標被
  // 重設，剛停掉的連線復活成殭屍。
  beforeDestroy() {
    window.removeEventListener("focus", this.handleWinFocus);
    if (this.idleTimerId) {
      clearInterval(this.idleTimerId);
      this.idleTimerId = null;
    }
    if (this.idleActivityHandler) {
      $("body").off("keydown mousemove mousedown", this.idleActivityHandler);
      this.idleActivityHandler = null;
    }
    if (this.conn && typeof this.conn.stop === "function") {
      this.conn.stop();
    }
  },
  methods: {
    // 閒置計時器：使用者有操作就重置 runTime，歸零代表閒置過久。
    // interval id 一定要存在 this 上，beforeDestroy 才清得掉。
    StartIdleTimer() {
      console.log("StartIdleTimer");
      const self = this;
      this.runTime = this.maxTime;
      if (this.idleTimerId) {
        clearInterval(this.idleTimerId);
      }
      this.idleTimerId = setInterval(function () {
        self.runTime--;

        if (self.runTime <= 0) {
          self.IdleTimeout();
          clearInterval(self.idleTimerId);
          self.idleTimerId = null;
        }
      }, 1000);
    },
    OpenURL() {
      var url = "/#/Chat?token=" + this.$route.query.token;
      ChatContainerHandler.OpenURL(url);
    },
    tabclass: function (provider) {
      if (
        provider.Code === this.roomInfo.ProviderCode &&
        this.roomInfo.ProviderCode === "LINE"
      ) {
        return "chTab line act";
      }
      if (provider.Code === "LINE") {
        return "chTab line ";
      }
      if (
        provider.Code === this.roomInfo.ProviderCode &&
        this.roomInfo.ProviderCode === "FB-TutorABC"
      ) {
        return "chTab fb act";
      }
      if (provider.Code === "FB-TutorABC") {
        return "chTab fb ";
      }
      if (
        provider.Code === this.roomInfo.ProviderCode &&
        this.roomInfo.ProviderCode === "FB-tutorJr"
      ) {
        return "chTab fb2 act";
      }
      if (provider.Code === "FB-tutorJr") {
        return "chTab fb2 ";
      }
      
      if (
        provider.Code === this.roomInfo.ProviderCode &&
        this.roomInfo.ProviderCode === "LINE-Abroad"
      ) {
        return "chTab line2 act";
      }
      if (provider.Code === "LINE-Abroad") {
        return "chTab line2 ";
      }

      if (
        provider.Code === this.roomInfo.ProviderCode &&
        this.roomInfo.ProviderCode === "WeChat"
      ) {
        return "chTab wechat act";
      }
      if (provider.Code === "WeChat") {
        return "chTab wechat";
      }

      if (
        provider.Code === this.roomInfo.ProviderCode &&
        this.roomInfo.ProviderCode === "WeChat-tutorabcmaiqi"
      ) {
        return "chTab wechat2 act";
      }
      if (provider.Code === "WeChat-tutorabcmaiqi") {
        return "chTab wechat2";
      }
      if (
        provider.Code === this.roomInfo.ProviderCode &&
        this.roomInfo.ProviderCode === "WeCom"
      ) {
        return "chTab wecom act";
      }
      if (provider.Code === "WeCom") {
        return "chTab wecom";
      }
    },
    //切換渠道
    ChangeProvider: function (chatRoomId, code) {
      if (code === "WeCom") {
        if (this.userProfiles && this.userProfiles.length > 0) {
          let profile = this.userProfiles.find(p => p.Provider && p.Provider.ProviderName === code);
          if (profile) {
            ww.openEnterpriseChat({
              externalUserIds: [ profile.UserId ],
              fail: function(res) {
                alert('打开企业微信聊天窗口失败, res:' + JSON.stringify(res));
              }
            });
          } else {
            alert("找不到相關資訊，暫時無法切換至對應的對話。");
          }
        }
        return;
      } else {
        var data = ChatContainerHandler.GeneralChatRoomUrl(
          chatRoomId,
          Global.current_staffid
        );

        var token = $.urlParam("token", data);

        var version = "0";
        if (this.$route.query.version != undefined) {
          version = this.$route.query.version;
        }
        var url =
          "?t=" +
          Math.random() +
          "/#/Chat2?token=" +
          token +
          "&version=" +
          version;
        if (this.$route.query.tct != undefined) {
          url = url + "&tct=" + this.$route.query.tct;
        }
      
        window.location.href = url;
      }
    },
    // 閒置逾時：由使用者無操作觸發，主動停止連線並要求確認後才重連。
    // 這條路徑跟網路斷線無關 —— 網路斷線由 SignalrConnectionHandler 自動重連。
    IdleTimeout() {
      console.log("IdleTimeout");
      const self = this;
      if (this.isAlert) {
        return;
      }
      this.conn.stop();
      this.$alert("頁面閒置過久,確認後重新整理頁面", "提示", {
        confirmButtonText: "確認",
        type: "warning",
        center: true,
        callback: (action) => {
          self.isAlert = false;
          self.conn.start();
          self.StartIdleTimer();
        },
      });
      this.isAlert = true;
    },
    handleWinFocus() {
      // 視窗回到前景時，如果連線已斷就立刻補一次重連，
      // 不用等退避排程，也不該把網路斷線誤報成閒置逾時。
      // initdata 失敗時 conn 仍是初始值，所以要先確認建立成功。
      if (this.conn && typeof this.conn.ensureConnected === "function") {
        this.conn.ensureConnected();
      }
    },
    async initWeComSDK() {
      const response = await http.get('/SCRMApp/GetCorpId');
      ww.register({
        corpId: response.data,
        jsApiList: ['getExternalContact', 'openEnterpriseChat'],
        getConfigSignature: async function (url) {
          try {
            const response = await http.post('/SCRMApp/GetConfigSignature', qs.stringify({ url: url }));
            return {
              nonceStr: response.data.NonceStr,
              timestamp: response.data.Timestamp,
              signature: response.data.Signature
            };
          } catch (error) {
            console.log(error);
          }
        },
        onConfigFail: function (res) {
          alert('企业微信JS-SDK 初始化失败, res:' + JSON.stringify(res));
        }
      });
    },
    initdata: function (token) {
      let loadingInstance = Loading.service({ fullscreen: true });

      try {
        this.conn = SignalrConnectionHandler.Create({
          url: this.$conf.MessageAPI + "/signalr",
          hub: "chatHub",
          // 首次連線與每次重連成功後都要重新取資料並重新加入聊天室
          onConnected: function (proxy) {
            proxy.invoke("GetDataByToken", token);
          },
          onStatusChange: (status) => {
            this.connStatus = status;
          },
        });
        Global.proxy = this.conn.proxy;

        this.conn.start();
      } catch (error) {
        alert(error);
        console.log(error);
      }

      this.initWeComSDK();
      
      //驗證鑰匙
      Global.proxy.on("checkKey", (data) => {
        if (data.status) {
          Global.current_roomid = data.roomId;
          Global.current_staffid = data.staffId;
          this.sessionId = data.chatsessionId;

          //加入對話
          Global.proxy.invoke(
            "joinRoom",
            Global.current_roomid,
            Global.current_staffid,
            this.sessionId
          );
        }
      });

      Global.proxy.on("joinRoom", (user) => {
        var that = this;
        that.staffInfo = user;

        //顯示訊息記錄
        //ChatContainerHandler.GetChatHistory();

        $.ajax({
          url: this.$conf.MessageAPI + "/Chat/GetChatHistory",
          type: "post",
          data: {
            roomId: Global.current_roomid,
            staffId: Global.current_staffid,
          },
          dataType: "json",
          success: function (data) {
            for (var i = 0; i < data.length; i++) {
              data[i].msgTime = this.convertUTCDateToLocalDate(data[i].msgTime);
            }
            this.messages = data;
          }.bind(this),
          error: function (a, b, c) {},
        });

        //檢查權限
        Global.proxy.invoke("CheckSpeaker", Global.current_roomid);
        Global.proxy.on("checkSpeaker", (speaker) => {
          store.dispatch("CheckSpeaker", speaker);
        });
      });
      //返回房間資訊
      Global.proxy.on("showGroupRoom", (room) => {
        if (room != null) {
          Global.current_roomid = room.RoomId;
          this.roomInfo = room;

          var that = this;
          //取得客戶渠道
          http
            .post(
              "Chat/GetChatRooms",
              qs.stringify({
                SocialLeadId: that.roomInfo.SocialLeadId,
                StaffID: Global.current_staffid,
              })
            )
            .then(function (response) {
              var data = response.data.Result;
              that.providerList = data;
            })
            .catch(function (error) {
              console.log(error);
            });
          
          // 获取 userProfiles
          if (that.roomInfo.SocialLeadId) {
            let socialLead = SocialPairedBasisInfoHandler.GetSocialLead(
              that.roomInfo.SocialLeadId,
              Global.current_staffid
            );
            if (socialLead && socialLead.UserProfiles) {
              that.userProfiles = socialLead.UserProfiles;
            }
          }
        }
      });
      //推播訊息
      Global.proxy.on("showGroupByRoomMsg", (data) => {
        if (data.RoomId == Global.current_roomid) {
          this.messages.push({
            Hid: data.Hid,
            frmId: data.frmId,
            UserName: data.UserName,
            Text: data.Text,
            msgTime: this.convertUTCDateToLocalDate(data.msgTime),
            msgType: data.msgType,
            filePath: data.filePath,
            previewImageUrl: data.previewImageUrl,
            senderType: data.senderType,
            UserPicture: data.UserPicture,
            quotedMessageId: data.quotedMessageId,
            quotedText: data.quotedText,
          });
        }
      });

      //訊息提示
      Global.proxy.on("showMessage", (data) => {
        this.$message({
          message: data,
        });
      });

      // //標題閃爍
      // Global.proxy.on("blinkTitle", data => {
      //   blinkTitle("[New Message]", "[新訊息]", 1000, true);
      // });

      //關閉頁面
      Global.proxy.on("closepage", (data) => {
        this.conn.stop();
        window.location.href = "/#/TextInfo";
      });
      loadingInstance.close();
    },
    stickerPackagesVisible: function () {
      return store_sticker.state.stickerPackagesVisible;
    },
  },
};
</script>

<style scoped>
.signalr-banner {
  padding: 6px 12px;
  background-color: #fdf6ec;
  color: #e6a23c;
  border-bottom: 1px solid #f5dab1;
  font-size: 13px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/ChatContainer.vue